export default __webpack_public_path__ + "static/media/html.5558826e.png";